import {AvatarPart} from "../common";

export default new AvatarPart({
	defs: [

	],
	render () {
		return `

		`;
	},
	attrs: {

	},
});



// WEBPACK FOOTER //
// ./src/top/blank.js